function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRight2 = function SvgRight2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21458"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1919",
    d: "M14 14H0V0h14z",
    style: {
      opacity: 0.87,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17703",
    d: "M11.267 11.533 8 8.267 11.267 5",
    transform: "rotate(180 8.265 7.625)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })));
};

export default SvgRight2;